<template lang="pug">
  .preorder(:class="{scrolling: scrollingShadowRight}")

    .shadowLBox(:style="{left:rowTitleWidth + 'px'}" :class="{active: scrollingShadowLeft}")
    .shadowRBox(:class="{active: scrollingShadowRight}")

    .scrollbox(v-dragscroll.x="true" @scroll="onScroll" ref="scrollbox")
      table.table
        tr
          th.row-label(ref="rowLabel")
            .label {{ matrix.labels.row }}
          th.col-label(v-for="col in colProp.options")
            .label {{ col.value }}
          th.mass-actions.col-label
            .label Alle
          th.price-sum.col-label
            .label Preis
        tr(v-for="(row, i) in matrix.rows")
          th.vertical-label
            component.row-label-cell(:is="row.image && row.image.src ? 'a' : 'div'" href="#" @click.stop.prevent="activateArticle(row)")
              .colorimage-cell(
                v-if="row.image && row.image.src"
                :style="{ backgroundImage: 'url(' + row.image.src + ')'}"
              )
              span.label {{ row.label }}
          td.articles(v-for="col in row.columns")
            PreorderArticle(
              :article="col.article"
              :valid="valid"
              :manageStock="manageStock"
            )
          td.mass-actions
            .buttons
              button.button.is-small.is-link.decrease(
                @click.prevent.stop="decrease(row)"
                :disabled="getQtySumInRow(row) <= 0"
              )
                svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
                  path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4")
              .qty-sum(v-if="(qty = getQtySumInRow(row))") {{ qty }}
              button.button.is-small.is-link.increase(
                @click.prevent.stop="increase(row)"
                :disabled="(max = getMaxQtyInRow(row)) && getQtySumInRow(row) >= max"
              )
                svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
                  path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6")
          td.price-sum
            .price(v-if="(price = getPriceSumInRow(row))") {{ price | moneyFormat(currency) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { get, debounce } from '@/helpers';
import { dragscroll } from 'vue-dragscroll';

import Matrix from './Matrix';
import PreorderArticle from './PreorderArticle';

export default {
    name: 'Preorder',
    extends: Matrix,
    data() {
        return {
            showShadowRight: false,
            scrollingShadowLeft: false,
            scrollingShadowRight: false,
            rowTitleWidth: 1
        };
    },
    components: {
        PreorderArticle
    },
    directives: {
        dragscroll
    },
    watch: {
        priceSum(value) {
            this.$emit('update:total', value);
        }
    },
    computed: {
        priceSum() {
            return this.matrix.rows.reduce((pr, cr) => {
                return (
                    pr +
                    cr.columns.reduce((pv, cv) => {
                        let price = get(cv.article, 'salePrice.value') || get(cv.article, 'price.value');
                        if (this.customer && this.customer.show_net_prices) {
                            price = get(cv.article, 'salePrice.net_value') || get(cv.article, 'price.net_value');
                        }
                        return pv + price * cv.cartQty;
                    }, 0)
                );
            }, 0);
        },
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup'
        })
    },
    methods: {
        onScroll(e) {
            setTimeout(() => {
                const { scrollLeft, clientWidth, scrollWidth } = e.target;

                if (this.showShadowRight) {
                    var maxScrollLeft = scrollWidth - clientWidth - 5;
                    scrollLeft >= maxScrollLeft
                        ? (this.scrollingShadowRight = false)
                        : (this.scrollingShadowRight = true);
                }

                scrollLeft > 1 ? (this.scrollingShadowLeft = true) : (this.scrollingShadowLeft = false);
            }, 100);
        },
        increase(row) {
            row.columns.forEach(col => {
                if (col.article && (!this.manageStock || col.cartQty < col.article.qty_sum)) {
                    this.addArticleToCart({ article: col.article, manageStock: this.manageStock });
                }
            });
        },
        decrease(row) {
            // this.total = 123;
            row.columns.forEach(col => {
                if (col.article) this.removeArticleFromCart({ article: col.article });
            });
        },
        getQtySumInRow(row) {
            return row.columns.reduce((pv, cv) => pv + cv.cartQty, 0);
        },
        getMaxQtyInRow(row) {
            let max = Infinity;
            if (this.manageStock) max = row.columns.reduce((pv, cv) => pv + get(cv.article, 'qty_sum'), 0);
            else if (row.columns.find(col => !col.article)) max = 0;
            return max;
        },
        getPriceSumInRow(row) {
            return row.columns.reduce((pv, cv) => {
                let price = get(cv.article, 'salePrice.value') || get(cv.article, 'price.value');
                if (this.customer && this.customer.show_net_prices) {
                    price = get(cv.article, 'salePrice.net_value') || get(cv.article, 'price.net_value');
                }
                return pv + price * cv.cartQty;
            }, 0);
        },
        ...mapActions({
            addArticleToCart: 'shop/addArticleToCart',
            removeArticleFromCart: 'shop/removeArticleFromCart'
        })
    },
    mounted() {
        const showShadows = () => {
            if (this.$refs.scrollbox && this.$refs.scrollbox.scrollWidth > this.$refs.scrollbox.clientWidth) {
                this.showShadowRight = true;
                this.scrollingShadowRight = true;
            }

            if (this.$refs.rowLabel.clientWidth >= 10) {
                this.rowTitleWidth = this.$refs.rowLabel.clientWidth - 10;
            }
        };

        window.addEventListener('resize', debounce(showShadows, 100));
        showShadows();
    }
};
</script>

<style lang="sass" scoped>

.preorder
  @apply border-1 relative
  z-index: 1
  user-select: none
  max-width: 1140px

  &.scrolling
    cursor: grab
  .scrollbox
    overflow-x: scroll


  .row-label,
  .vertical-label
    background-color: #f7f7f7
    z-index: 100
    padding-left: 8px
    @screen md
      @apply sticky left-0
      font-size: 0.85em

  .shadowLBox,
  .shadowRBox
    @apply absolute h-full top-0 transition-all duration-200 ease-in-out
    box-shadow: 0
    clip-path: inset(0px)
    width: 10px
    z-index: 100
    &.active
      box-shadow: 0 0 15px rgba(0,0,0,0.75)

  .shadowLBox
    &.active
      @screen md
        clip-path: inset(0px -15px 0px 0px)
  .shadowRBox
    right: -10px
    &.active
      clip-path: inset(0px 0px 0px -15px)

table
  @apply  w-full
  border-spacing: 0
  border-collapse: separate
  .row-label-cell
    display: flex
    align-items: center
    .label
      line-height: 1

    .colorimage-cell
      margin-right: 5px
      padding: 0 !important
      width: 30px
      height: 30px
      background-position: center
      background-size: cover
      background-repeat: no-repeat
      border-radius: 50%

  td, th
    @apply border-1 border-r-0 border-b-0 p-1
    &:first-child
      @apply border-l-0
  tr:first-of-type
    td, th
      @apply border-t-0

  td:nth-child(2)
      ::v-deep .qtyInfo
        background-image: url('~@/assets/stock.png')
        background-repeat: no-repeat
        background-size: 14px
        background-position: 4px 2px
  td
    min-width: 100px


  tr.hr td
    padding-top: 0.5rem

  td.has-button
    width: 1px

  .label
    @apply font-medium

  .buttons
    margin: 0 -2px
    .button
      margin: 0 2px

  .vertical-label
    padding-right: calc(1rem - 2px)
    white-space: nowrap
    width: 120px

  .row-label,
  .col-label
    @apply text-center p-2 bg-gray-100
  .articles
    padding: 0

  th.mass-actions,
  th.qty-sum,
  th.price-sum
    width: 1px
    min-width: 100px

  .mass-actions,
  .qty-sum
    text-align: center
  .price-sum
    text-align: right
    vertical-align: top
    .price
      line-height: 32px

  .qty-sum
    padding: 0 0.25rem
    line-height: 32px

td.mass-actions
  vertical-align: top
  .buttons
    @apply flex items-center justify-between
    height: 38px
    button.button
      padding: .3rem
      width: 2rem
      height: 2rem
      @screen 2xl
        padding: .3rem
        width: 1.5rem
        height: 1.5rem
      flex-shrink: 0
      &:hover,
      &:focus,
      &:active
        z-index: 1
</style>
